/** Layer types an operator can create; mirrors the console's factory. */
export const LAYER_CREATE_TYPE_OPTIONS = [
  { value: "feature", label: "Feature" },
  { value: "group", label: "Group" },
  { value: "map-image", label: "Map image" },
  { value: "wms", label: "WMS" },
  { value: "ogc-feature", label: "OGC feature" },
  { value: "scene", label: "Scene (3D)" },
] as const

/** Starter draft for the manual path (no probed source). */
export const LAYER_CREATE_MANUAL_CONFIGURATION = `{
  "url": ""
}`

/**
 * Stable preview subject code: the map preview keys its applied-draft state
 * on the subject's feature code, so the real (still-being-typed) code would
 * reset the preview on every keystroke.
 */
export const LAYER_CREATE_PREVIEW_CODE = "MapLayer_Create_Preview"
